import "./Common/Header.api";
export { HeaderMobile } from "./Mobile/HeaderMobile.container";

export type HeaderActions =
  | "home.request"
  | "home.available.set"
  | "home.enabled.set"
  | "plugin.request"
  | "plugin.available.set"
  | "plugin.enabled.set"
  | "pluginmenubutton.icon.set";
